import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Welcome.css';

const services = [
    {
        id: 'blog-writer',
        name: 'Blog Writer',
        description: 'Generate AI-powered blog posts in your unique author style',
        icon: '✍️',
        path: '/blog-writer',
        available: true,
        features: ['Custom voice profiles', 'Multiple AI providers', 'Image generation']
    },
    {
        id: 'leadpages',
        name: 'Leadpages',
        description: 'Generate landing pages styled after your beehiiv blog',
        icon: '🎯',
        path: '/leadpages',
        available: true,
        features: ['Blog style analysis', 'Multiple unique formats', 'In-browser preview & AI edits']
    },
];

function Welcome() {
    const { user } = useAuth();

    return (
        <div className="welcome-page">
            <div className="welcome-header">
                <h1>Welcome back, <span className="gradient-text">{user?.name}</span></h1>
                <p>Select a service to get started with AI-powered content generation</p>
            </div>

            <div className="services-grid">
                {services.map((service) => (
                    <div key={service.id} className={`service-card ${!service.available ? 'disabled' : ''}`}>
                        <div className="service-icon">{service.icon}</div>
                        <h3>{service.name}</h3>
                        <p>{service.description}</p>

                        <ul className="service-features">
                            {service.features.map((feature, idx) => (
                                <li key={idx}>
                                    <span className="feature-check">✓</span>
                                    {feature}
                                </li>
                            ))}
                        </ul>

                        {service.available ? (
                            <Link to={service.path} className="btn-primary service-btn">
                                Get Started
                            </Link>
                        ) : (
                            <button className="btn-secondary service-btn" disabled>
                                Coming Soon
                            </button>
                        )}
                    </div>
                ))}
            </div>

            <div className="welcome-stats glass">
                <div className="stat">
                    <span className="stat-value gradient-text">∞</span>
                    <span className="stat-label">Articles Generated</span>
                </div>
                <div className="stat">
                    <span className="stat-value gradient-text">4</span>
                    <span className="stat-label">AI Providers</span>
                </div>
                <div className="stat">
                    <span className="stat-value gradient-text">5</span>
                    <span className="stat-label">Image Styles</span>
                </div>
            </div>
        </div>
    );
}

export default Welcome;
